import script from "./chart3.vue?vue&type=script&setup=true&lang=js"
export * from "./chart3.vue?vue&type=script&setup=true&lang=js"

import "./chart3.vue?vue&type=style&index=0&id=39adb56f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39adb56f"]])

export default __exports__